// extracted by mini-css-extract-plugin
export default {"cardWrapper":"poc-detail-card_cardWrapper__G77Zy","contentWrapper":"poc-detail-card_contentWrapper__YfOYG"};